import { Component, OnInit, ViewChild, ElementRef, ViewContainerRef, Input } from '@angular/core';
//import { DynamicGridComponent } from '../../components/dynamic-grid/dynamic-grid.component';
import { UpperCasePipe } from '@angular/common/src/pipes';
import { columnDataType, GridColumnDefinition } from '../../components/dynamic-grid/grid';
import { forEach } from '@angular/router/src/utils/collection';
import { isJsObject } from '@angular/core/src/change_detection/change_detection_util';
import * as go from "gojs";
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';


import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SchemaPropertyNode } from "../../components/SchemaPropertyNode";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { UUID } from "angular2-uuid";

import { EntityConfigurationService } from "../../entity-services/features/entityConfiguration/entity-configuration.service";
import { ComponentInteractionService } from '../../entity-services/component-interaction.service';
import { DatavirtualizationService } from '../../entity-services/features/dataVirtualization/datavirtualization.service';
import { AdminPortalAPIService } from '../../entity-services/admin-portal-api.service';
import { GridService } from '../../entity-services/grid.service';
import { InputPropertyList } from '../../entity-services/InputPropertyList';
import { TimeseriesChartComponent } from '../../components/timeseries-chart/timeseries-chart.component';

@Component({
  selector: 'app-entity-viewer-demo',
  template: `<div id="sample">
  <div class="maskDiv" *ngIf="entityConfigurationService.isOperationInProgress">
    <i class="fa fa-gear fa-spin maskSpin"></i>
  </div>
  <div style="width: 100%; display: flex; justify-content: space-between; height: calc(100vh - 67px);float: left; overflow-x: auto;overflow-y: hidden;">
    <div id="entityTypes" class="entityTypeSection pull-left">
      <ul id="grouplist" class="list-group">
        <li class="list-group-item header">Entity Type
        </li>
        <li class="list-group-item" *ngFor="let item of entityTypes" [ngClass]="{'active': selectedEntityType == item}" (click)="OnClickEntityType(item)">
          {{ item }}
        </li>
      </ul>
    </div>

    <div id="myPaletteDiv" class="pull-left" style="display:none;width: 100px; margin-right: 2px; background-color: whitesmoke; border: solid 1px black"></div>

    <div id="entityInstanceDiv" class="entityInstanceSection pull-left" *ngIf="!!selectedEntityType">
      <ul class="list-group">
        <li class="list-group-item header">{{selectedEntityType}} Instance
        </li>
        <li class="list-group-item" [ngClass]="{'active': selectedEntityInstance == item}" (click)="OnClickEntityInstance(item)"
          draggable="true" (dragstart)="dragStart($event,item.id,'Node')" *ngFor="let item of entityInstances">
          {{ item.name}}
        </li>
      </ul>
    </div>
    <div style="flex-grow: 1; height: calc(100vh - 80px); margin-top:5px;" class="pull-left">
      <div id="myDiagramDiv" (drop)="dropOnDiagram($event)" (dragover)="dragOverOnDiagram($event)" style="flex-grow: 1; margin-top:10px; height: calc(100vh - 82px);border:1px solid #ccc;min-width:1000px;"></div>
    </div>

    <div [hidden]="IsHideEntityDetails" class="pull-left" style="height:calc(100vh - 77px);position:relative; max-width:300px; margin-left:4px;background-color:#fff; border: solid 1px#ccc; margin-top: 10px;">

      <div class="detailsection-header">
        <i (click)="showEntityProperties()" class="fa fa-close"></i>
      </div>
      <div style="overflow-y: auto; z-index:9;width:100%;height: calc(100vh - 140px);margin-top:45px;">


        <table>
          <tbody>
            <tr *ngFor="let property of stringProperties; let i = index">
              <td style="padding-left: 10px;">
                <b> {{ property.name }} : </b>
              </td>
              <td>{{ property.value }}</td>
            </tr>
            <tr *ngFor="let property of arrayProperties; let i = index">
              <td>
                <b>{{ property.name }} :</b>
              </td>
              <td>
                <select class="form-control"    placeholder="property.name">
                  <option value="">Please select a {{property.name}}</option>
                    <option  *ngFor="let role of property.value"  >{{role }}</option>
                    </select>
              </td>
            </tr>
            <tr *ngIf="isTimeseriesExist">
              <td>
                <b>Timeseries Id :</b>
              </td>
              <td>
                <select class="form-control pull-left" title="Select Timeseries Id" (change)="OnChnageTimeSeriesId($event.target.value)">
                  <option value="" selected>Select Timeseries Id</option>
                  <option *ngFor="let tid of timeseriesIdList" [value]="tid.value">{{tid.value}}</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>

      </div>


      <!-- display chart -->

    </div>
  </div>
</div>

<!-- Modal for Timeseries-->


<div id="displayTimeseriesModel" class="modalPopup">
  <!-- Modal content -->

  <div class="modalPopup-content">

    <div style="text-align: right">
      <span class="buttonClose" (click)="closeTimeseriesMetrix()">&times;</span>
    </div>
    <span>
      <h2> Timeseries Metrics</h2>
    </span>

    <app-timeseries-chart style="width: 100%"></app-timeseries-chart>


    <div style="text-align: center">
      <br/>
      <br/>
      <br/>
      <button type="button" class="button" (click)="closeTimeseriesMetrix()">Close</button>
    </div>
  </div>

</div>`,
  styles: [`#entityInstanceDiv .list-group,.entityTypeSection .list-group{height:calc(100vh - 79px);overflow-y:auto;padding-left:0}.relationTypesSection .list-group{position:absolute;top:0;bottom:45px;overflow-y:auto;left:0;right:0}#entityInstanceDiv .list-group:hover{overflow-y:auto}#entityInstanceDiv .list-group-item{word-wrap:break-word;border:1px solid #d3d3d3;border-radius:2px}.entityTypeSection{margin-right:2px;background-color:#f5f5f5;border:1px solid #ccc;margin-top:10px}.entityTypeSection .header{background:#87ceeb}.entityInstanceSection{margin-right:2px;background-color:#f5f5f5;border:1px solid #ccc;margin-top:10px}.entityInstanceSection .list-group{overflow-y:auto}.entityInstanceSection .list-group:hover{overflow-y:hidden}.entityInstanceSection .list-group-item.header{background:rgba(100,211,245,.95)}.entityInstanceSection .list-group-item{background:#f5f5f5}.entityInstanceSection .list-group-item:hover,.list-group .list-group-item.header{background:rgba(100,211,245,.95)}.addRelation{display:block}.uploadEntity{display:none}.modalPopup{display:none;position:fixed;z-index:30;padding-top:50px;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4);font-size:16px}.modalPopup-content{background-color:#fefefe;margin:auto;padding:40px;border:1px solid #888;width:70%;height:90%;overflow-y:scroll;font-size:16px}.button{background-color:#dd4848;border:none;color:#fff;padding:10px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin:4px 2px;cursor:pointer;border-radius:12px}.buttonClose{background-color:#dd4848;border:none;color:#fff;padding:2px;text-align:center;text-decoration:none;display:inline-block;font-size:22px;margin:2px;cursor:pointer;border-radius:12px}.modal-header{background:#4c4c4c;background:-webkit-gradient(linear,left top,left bottom,from(#4c4c4c),color-stop(7%,#2c2c2c),color-stop(7%,#2c2c2c),color-stop(12%,#595959),color-stop(14%,#474747),color-stop(14%,#474747),color-stop(25%,#666),color-stop(51%,#000),color-stop(60%,#111),color-stop(76%,#2b2b2b),color-stop(91%,#1c1c1c),to(#131313));background:linear-gradient(to bottom,#4c4c4c 0,#2c2c2c 7%,#2c2c2c 7%,#595959 12%,#474747 14%,#474747 14%,#666 25%,#000 51%,#111 60%,#2b2b2b 76%,#1c1c1c 91%,#131313 100%);color:#f5f5f5}.modal-header .close,.modal-header .close:hover{color:#fff;float:left}.adminModalResiable .modal-content{overflow:hidden;resize:both}.regular-checkbox{-webkit-appearance:none;background-color:#fafafa;border:1px solid #cacece;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);padding:7px;border-radius:3px;display:inline-block;position:relative;margin-bottom:-3px}.required{color:red}.regular-checkbox:active,.regular-checkbox:checked:active{-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1)}.regular-checkbox:checked{background-color:red;border:1px solid red;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);color:#99a1a7}.hidden{display:none}#showRelationDiv{margin-top:10px;margin-right:4px;background:#f5f5f5;border:1px solid #ccc;min-width:129px;position:relative}.list-group-item{padding:.3rem 1rem!important;display:flow-root;white-space:nowrap;-ms-flex-flow:nowrap;flex-flow:nowrap}.addRelation{position:absolute;bottom:0}.list-group-item.active{border:3px solid #7171da;background-color:#8b8bd8}.entityInstanceSection .list-group-item.active{color:#000!important;border:3px solid #7171da;background-color:#8b8bd8}.entityTypeSection .list-group-item{color:#474545!important;border:1px solid #d3d3d3;border-radius:2px}.maskDiv{padding:50%;background:rgba(100,211,245,.95);position:fixed;z-index:80000;height:100%;width:100%;overflow:show;margin:10px;top:0;left:0;bottom:0;right:0;opacity:.5}.maskDiv .maskSpin{font-size:36px;color:green;z-index:90000}.detailsection-header{background:rgba(100,211,245,.95);float:left;width:100%;text-align:right;padding:10px}`],
  providers: [GridService]
})
export class EntityViewerDemoComponent implements OnInit {

  myDiagram: any;
  relationshipPalette: any;
  newRelatioName: string;
  IsHideRelationPanel: boolean = true;
  graphLinkArray: any[];
  $: any;
  entityArray: any;
  entityProperties: any[] = [];
  IsHideEntityDetails: boolean = true;
  entities: any[] = [];
  entityTypes: any[];
  selectedEntityType: any;
  entityInstances: any[];
  entityInstancePaletteDiv: any;
  isSaveEnabled = false;
  arrayProperties: ArrayProperties[];
  stringProperties: StringProperties[];
  timeseriesIdList: ArrayProperties[];
  isTimeseriesExist: boolean = false;
  relationTypes: { id: string, text: string }[] = [];
  entitySchemaList: any[] = [];
  selectedSchema: any;
  selectedEntityInstance: any;
  colorArr = [];
  nodeDataArray: any[] = [];
  linkDataArray: any[] = [];
  pointPosition: PointPosition = new PointPosition();
  responseData: any[];

  @Input() inputProperty: InputPropertyList;

  ngOnInit() {
    
    console.log(this.inputProperty);
    this.entityConfigurationService.assignInputPropertyValues(this.inputProperty);
    this.getEntitySchemaList();
    this.createERDiagram();
    document.getElementById("displayTimeseriesModel").style.display = "none";
  }
  
  constructor(private http: Http, private componentInteractionService: ComponentInteractionService, private modalService: NgbModal,
    public entityConfigurationService: EntityConfigurationService,
    public datavirtualization: DatavirtualizationService,
    public toastr: ToastsManager, vcr: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vcr);

  }
  OnChnageTimeSeriesId(timeseriesId) {
    this.componentInteractionService.NotifyTimeseriesIdChangeEvent(timeseriesId);
    document.getElementById("displayTimeseriesModel").style.display = "block";
  }
  closeTimeseriesMetrix() {
    document.getElementById("displayTimeseriesModel").style.display = "none";
  }

  getEntityTypeColor(entityType: string): string {

    let index = this.entityTypes.indexOf(entityType);
    if (index > -1 && index < this.colorArr.length - 1) {
      return this.colorArr[index];
    }
    else {
      var color = "rgb( 0,0,0)";
        
      this.colorArr.push(color);
      return color;
    }

  }

  
    displayEntityDetails(data) {
    this.IsHideEntityDetails = false;
    let aa = data;
    this.entityProperties = this.entityInstances.find(x => x.id == data.key);
    let stringProperties = new Array<StringProperties>();
    let arrayProperties = new Array<ArrayProperties>();
    let timeseriesIdList = new Array<ArrayProperties>();
    Object.keys(aa).forEach(function (key) {

      if ( key == "timeseriesid" && aa[key] != "undefined" && aa[key] != "") {
        let properties = new ArrayProperties();
        properties.name = key;
        properties.value = aa[key];
        timeseriesIdList.push( properties);
      }
      else if (typeof aa[key] == 'string') {

        let curProperties = new StringProperties();
        curProperties.name = key;
        curProperties.value = aa[key];
        stringProperties.push(curProperties);
      }
      else if (aa[key] instanceof Array) {
        let properties = new ArrayProperties();
        properties.name = key;
        properties.value = aa[key];
        arrayProperties.push( properties);

      }
    });
    this.stringProperties = stringProperties;
    this.arrayProperties = arrayProperties;
    this.timeseriesIdList = timeseriesIdList;
    this.isTimeseriesExist = this.timeseriesIdList.length > 0 ? true : false;
  }

  showEntityProperties() {
    this.IsHideEntityDetails = !this.IsHideEntityDetails;
  }

  getEntitySchemaList() {
    this.entityConfigurationService.getSchemas().subscribe(res => {
      if (res) {
        this.entitySchemaList = res.map(item => item.schemaData);
        this.getEntityTypes();
      }
    }, error => {
      this.toastr.error("Unable to fetch Schema List");
    })
  }

  getEntityTypes() {
    this.entityTypes = this.entitySchemaList.map(item => item.title);
  }

  //On Click on Entity Type fron LIst
  OnClickEntityType(item) {
    this.selectedEntityType = item;
    this.selectedEntityInstance = null;
    this.entityConfigurationService.getEntitiesByEntityType(this.selectedEntityType).subscribe(res => {
      this.entityInstances = res;
    }, error => {
      this.toastr.error(`Error while fetching data`, "Error!");
    });
  }

  OnClickEntityInstance(item) {
    this.selectedEntityInstance = item;
    this.nodeDataArray = [];
    this.linkDataArray = [];
    this.myDiagram.model.linkDataArray = [];
    this.myDiagram.model.nodeDataArray = [];
    var nodeArray = [];
    var linkArray = [];
    item["level"] = 1;
    item["isExpand"] = false;
    nodeArray.push(item);
    this.createDataforChart(item, nodeArray, linkArray);
    this.expandNode(item);

    
  }

  expandNode(parentNode: any) {
    if (parentNode["isExpand"]) {
      return;
    }
    let nodeArray = [];
    let linkArray = [];
    this.entityConfigurationService.getEntityRelationshipsBySourceId(parentNode.id).subscribe(res => {
      
      console.log(res);
      this.entityConfigurationService.getEntitesByRelationships(res).subscribe(listOfentities => {
        
         parentNode["isExpand"] = true;
      
        listOfentities.forEach(item => {
          if (item.constructor === Array) {
            nodeArray = nodeArray.concat(item);
          }
          else {
            nodeArray.push(item);
          }
        })
        nodeArray = nodeArray.filter(node => {
          return !this.myDiagram.model.nodeDataArray.find(item => item.key === node.id)
        })
        linkArray = res.filter(relation => {
          return !this.myDiagram.model.linkDataArray.find(item => item.key === relation.id)
        });
        nodeArray.forEach(item => {
          item["level"] = parentNode.level + 1;
        })
        this.createDataforChart(parentNode, nodeArray, linkArray);
      });
    });
  }

  createDataforChart(parentNode: any, nodes, entityRelationships) {
    var count = 0;
    nodes.forEach(element => {
      var axes = new go.Point(Math.random() * 600, Math.random() * 300);
      var obj = element ? element : element[0];
      obj["text"] = obj.name;
      let location = this.getPointPosition(parentNode, obj, count);
      obj["loc"] = `${location.xAxis} ${location.yAxis}`;
      obj["xAxis"] = location.xAxis;
      obj["yAxis"] = location.yAxis;
      obj["key"] = obj.id
      this.nodeDataArray.push(obj);
      this.myDiagram.model.addNodeData(obj)
      count = count + 1;
    });

    entityRelationships.forEach(element => {
      var linkNode =
        {
          "from": element.sourceentityid, "to": element.destinationentityid, "text": element.relationshiptype, "key": element.id
        }
      this.myDiagram.model.addLinkData(linkNode);
    });

  }

  getPointPosition(parentNode, node, childNumber: number): any {

    //Root Node
    if (parentNode.key === node.key) {
      return { xAxis: -260, yAxis: -290 };
    }
    else {
      let parentX = parentNode["xAxis"];
      let parentY = parentNode["yAxis"];
      let siblingNodes = this.myDiagram.model.nodeDataArray.filter(item => item.level === node.level);
      if (siblingNodes.length) {
        let maxXAxis = Math.max(...siblingNodes.map(item => item.xAxis));
        return { xAxis: maxXAxis + 130, yAxis: (parentY + 120) };
      }
      else {
        return { xAxis: (parentX + (childNumber * 130) - 150), yAxis: (parentY + 120) };
      }
    }

  }

  showPoint(loc) {
    var docloc = this.myDiagram.transformDocToView(loc);
    alert("Selected node location,\ndocument coordinates: " + loc.x.toFixed(2) + " " + loc.y.toFixed(2) +
      "\nview coordinates: " + docloc.x.toFixed(2) + " " + docloc.y.toFixed(2));
  }

  createERDiagram() {
    var $ = go.GraphObject.make;  // for conciseness in defining templates
    var thisObj = this;
    this.myDiagram =
      $(go.Diagram, "myDiagramDiv",  // must name or refer to the DIV HTML element
        {
          grid: $(go.Panel, "Grid",
            $(go.Shape, "LineH", { stroke: "lightgray", strokeWidth: 0.5 }),
            $(go.Shape, "LineH", { stroke: "gray", strokeWidth: 0.5, interval: 10 }),
            $(go.Shape, "LineV", { stroke: "lightgray", strokeWidth: 0.5 }),
            $(go.Shape, "LineV", { stroke: "gray", strokeWidth: 0.5, interval: 10 })
          ),
          "draggingTool.dragsLink": true,
          "draggingTool.isGridSnapEnabled": true,
          "linkingTool.isUnconnectedLinkValid": true,
          "linkingTool.portGravity": 20,
          "relinkingTool.isUnconnectedLinkValid": true,
          "relinkingTool.portGravity": 20,
          "relinkingTool.fromHandleArchetype":
          $(go.Shape, "Diamond", { segmentIndex: 0, cursor: "pointer", desiredSize: new go.Size(8, 8), fill: "tomato", stroke: "darkred" }),
          "relinkingTool.toHandleArchetype":
          $(go.Shape, "Diamond", { segmentIndex: -1, cursor: "pointer", desiredSize: new go.Size(8, 8), fill: "darkred", stroke: "tomato" }),
          "linkReshapingTool.handleArchetype":
          $(go.Shape, "Diamond", { desiredSize: new go.Size(7, 7), fill: "lightblue", stroke: "deepskyblue" }),
          initialAutoScale: go.Diagram.Uniform,
          "linkingTool.direction": go.LinkingTool.ForwardsOnly,
          layout: $(go.LayeredDigraphLayout, { isInitial: false, isOngoing: false, layerSpacing: 50 }),
          
          // start everything in the middle of the viewport
          initialContentAlignment: go.Spot.Center,
          
          // have mouse wheel events zoom in and out instead of scroll up and down
          "toolManager.mouseWheelBehavior": go.ToolManager.WheelZoom,
          // support double-click in background creating a new node
          // "clickCreatingTool.archetypeNodeData": { text: "new node" },
          // enable undo & redo
          "undoManager.isEnabled": false,
          allowCopy: false,
          allowInsert: false,
          allowLink: false,
          isReadOnly: false,
        });

    // define the Node template
    this.myDiagram.nodeTemplate =
      $(go.Node, "Auto",
        new go.Binding("location", "loc", go.Point.parse),
        // define the node's outer shape, which will surround the TextBlock
        $(go.Shape, "RoundedRectangle",
          {
            parameter1: 20,  // the corner has a large radius
            fill: $(go.Brush, "Linear", { 0: "rgb(254, 201, 0)", 1: "rgb(254, 162, 0)" }),
            stroke: null,
            portId: "",  // this Shape is the Node's port, not the whole Node
            fromLinkable: true, toLinkable: true, cursor: "pointer",
            toEndSegmentLength: 50, fromEndSegmentLength: 40
          }),
        $(go.TextBlock,
          {
            editable: false, // editing the text automatically updates the model data
            width: 80,
            textAlign: "center",
            font: "8pt helvetica, arial, sans-serif"
          },
          { // second arg will be this GraphObject, which in this case is the Node itself:
            
          },
          new go.Binding("text").makeTwoWay())
      );

    // unlike the normal selection Adornment, this one includes a Button
    this.myDiagram.nodeTemplate.selectionAdornmentTemplate =
      $(go.Adornment, "Spot",
        $(go.Panel, "Auto",
          $(go.Shape, { fill: null, stroke: "blue", strokeWidth: 2 }),
          $(go.Placeholder)  // a Placeholder sizes itself to the selected Node
        ),
        // the button to create a "next" node, at the top-right corner
        $("Button",
          {
            alignment: go.Spot.TopRight,
            click: addNodeAndLink  
          },
          $(go.Shape, "PlusLine", { width: 6, height: 6 })
        ) // end button
      ); // end Adornment

    // clicking the button inserts a new node to the right of the selected node,
    // and adds a link to that new node
    function addNodeAndLink(e, obj) {
      var adornment = obj.part;
      var diagram = e.diagram;
      diagram.startTransaction("Add State");

      // get the node data for which the user clicked the button
      var fromNode = adornment.adornedPart;
      var fromData = fromNode.data;
      // create a new "State" data object, positioned off to the right of the adorned Node
      var toData = { text: "new" };
      var p = fromNode.location.copy();
      p.x += 200;
      //toData.loc = go.Point.stringify(p);  // the "loc" property is a string, not a Point object
      // add the new node data to the model
      var model = diagram.model;
      model.addNodeData(toData);

      // create a link data from the old node data to the new node data
      var linkdata = {
        from: model.getKeyForNodeData(fromData),  // or just: fromData.id
        to: model.getKeyForNodeData(toData),
        text: "transition"
      };
      // and add the link data to the model
      model.addLinkData(linkdata);

      // select the new Node
      var newnode = diagram.findNodeForData(toData);
      diagram.select(newnode);

      diagram.commitTransaction("Add State");

      // if the new node is off-screen, scroll the diagram to show the new node
      diagram.scrollToRect(newnode.actualBounds);
    }

    // replace the default Link template in the linkTemplateMap
    this.myDiagram.linkTemplate =
      $(go.Link,  // the whole link panel
        {
          curve: go.Link.Bezier, adjusting: go.Link.Stretch,
          reshapable: true, relinkableFrom: true, relinkableTo: true,
          toShortLength: 3
        },
        new go.Binding("points").makeTwoWay(),
        new go.Binding("curviness"),
        $(go.Shape,  // the link shape
          { strokeWidth: 1.5 }),
        $(go.Shape,  // the arrowhead
          { toArrow: "standard", stroke: null }),
        $(go.Panel, "Auto",
          $(go.Shape,  // the label background, which becomes transparent around the edges
            {
              fill: $(go.Brush, "Radial",
                { 0: "rgb(240, 240, 240)", 0.3: "rgb(240, 240, 240)", 1: "rgba(240, 240, 240, 0)" }),
              stroke: null
            }),
          $(go.TextBlock, "transition",  // the label text
            {
              textAlign: "center",
              font: "9pt helvetica, arial, sans-serif",
              margin: 4,
              editable: true  // enable in-place editing
            },
            // editing the text automatically updates the model data
            new go.Binding("text").makeTwoWay())
        )
      );

    // read in the JSON data from the "mySavedModel" element
   
    this.myDiagram.addDiagramListener("ObjectSingleClicked",
      function (e) {
        var part = e.subject.part;
        if (!(part instanceof go.Link)) {
          thisObj.displayEntityDetails(part.data);
          thisObj.expandNode(part.data);
          
        }
      });
  }
}

export class PointPosition {
  count: number;
  XAxis: number;
  YAxis: number;
}

export class StringProperties {
  name: string;
  value: string;
}

export class ArrayProperties {
  name: string;
  value: any;
}